import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useUserDetails } from "../../../context/auth";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";

function LeaveApproval() {
  const [employeeData, setemployeeData] = useState([]);

  const [ID, setID] = useState("");

  const navigate = useNavigate();
  const { HRRoleLeave, ManagerLeave, AccessData, HRLIST } = useUserDetails();

  let Roledata = JSON.parse(sessionStorage.getItem("MainApp"));  
  
  const locatdatas = JSON.parse(sessionStorage.getItem("user"));
  const [Alldata, setAlldata] = useState("");
  const [display, setdisplay] = useState(false);
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getemployeedata(id);
    }
  }, []);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const getemployeedata = async (id) => {
    const query = ` query GetLeaveById($id: String!) { 
        getLeaveById(id: $id) {
          data {
            id
            reason
            totalDays 
            user{
              id
              firstName
              lastName
            }
            status
            teamApproval
            hrApproval
            teamleaderId
            leaveFrom   
            leaveTill  
            leaveType{
              id
              name
            }
            primaryDor{
              firstName
              lastName
            }
            secondaryDor{
              firstName
              lastName
            } 
            attachment
            approvalStatus{
              id
              approver{
                id
                firstName
                lastName
              }
            }
            followUpTasks
          }
          success
          error
          message
        }
      }`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const leaveDatass = response.data.data.getLeaveById?.data[0];
      setAlldata(leaveDatass);      
      setemployeeData(leaveDatass);

      const hasManagerPermission =
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "ApplyLeave" &&
            item.component === "ManagerApproval" &&
            item.can_access
        );

      const hasHrPermission =
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "ApplyLeave" &&
            item.component === "HrApproval" &&
            item.can_access
        );

      if (hasManagerPermission && hasHrPermission) {
        
        //HRList is HR Manager or any Manager from Team List and HR is HR Tab
        if (Roledata === "HRList") {          
          if (leaveDatass.teamApproval == "Pending") {
            setdisplay(true);
          } else {
            setdisplay(false);
          }
        } else if (Roledata === "HR") {           
          if (
            leaveDatass.teamApproval == "approved" &&
            leaveDatass.hrApproval == "pending"
          ) {
            setdisplay(true);
          } else {
            setdisplay(false);
          }
        }
      } else if (hasManagerPermission && !hasHrPermission) {
        if (leaveDatass.teamApproval == "Pending") {
          setdisplay(true);
        } else {
          setdisplay(false);
        }
      } else if (hasHrPermission && !hasManagerPermission) {
      
        if (Roledata == "HR") {
          if (
            leaveDatass.teamApproval == "approved" &&
            leaveDatass.hrApproval == "pending"
          ) {
            setdisplay(true);
          } else {
            setdisplay(false);
          }
        }
      }

    } catch (error) {
      console.error("ReponseError:", error);
      Swal.fire({
          position: "center",
          icon: "error",
          title: error?.response?.data?.errors[0]?.message || "Network Error!",
          showConfirmButton: false,
          timer: 2500,
      });
    }
  };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    let query;
    let variables;
    
    if (Roledata === "HRList") {
      query = `mutation leaveManagerApproval($id:String! $status:String! $approver_id:ID! $screen_name: String!){  
      leaveapprovalmanager(id:$id status:$status approverId: $approver_id screenName: $screen_name){  
        leaveApprovalManager{  
          id  
          requestedOn  
          leaveType {
            id
            name
          }
          leaveFrom  
          leaveTill  
          totalDays  
          halfDay  
          reason  
          status
          teamleaderId
          teamApproval  
          hrApproval
          approvalStatus{
            id
            approver{
              id
              firstName
              lastName
            }
          }
        }  
      }  
    }
  `;

      variables = {
        id: +ID,
        status: statusdata,
        approver_id: locatdatas?.id,
        screen_name: "Leave Approval",
      };
    } else {
      // HR approval
      query = `mutation leaveHrApproval($id:String! $status:String!){  
        leaveapprovalhr(id:$id status:$status){ 
          leaveApprovalHR{  
            id
            requestedOn  
            leaveType {
              id
              name
            }
            leaveFrom  
            leaveTill  
            totalDays  
            halfDay  
            reason 
            status
            teamleaderId  
            teamApproval  
            hrApproval
            approvalStatus{
              id
              approver{
                id
                firstName
                lastName
              }
            }
          }  
        }  
      }`;

      variables = {
        id: +ID,
        status: statusdata,
      };
    }

    try {
      const response = await axios.post(
        BASEURL, // Replace with your actual GraphQL endpoint
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );      

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (response.data.data?.leaveapprovalhr?.leaveApprovalHR) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/apply-leave");
      } 
      else if(response.data?.errors){
        const message = response.data?.errors.errors[0].message        
        
         Swal.fire({
          position: "center",
          icon: "error",
          title:message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
      else if (
        response.data.data?.leaveapprovalmanager?.leaveApprovalManager
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/apply-leave");
      }
      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);      
      Swal.fire({
        position: "center",
        icon: "error",
        title: error?.response?.data?.errors[0]?.message || "Network Error!",
        showConfirmButton: false,
        timer: 2500,
      });
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/apply-leave");
  };

  const getFormattedLeaveType = (leaveType) => {
    return leaveType
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 2, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold" textAlign="center">
                Leave Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.user?.firstName?.toUpperCase() + " " + employeeData.user?.lastName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave Type:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {getFormattedLeaveType(employeeData.leaveType?.name)}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave From:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveFrom}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave Till:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveTill}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Total Days:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.totalDays}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.reason}
                  </span>
                </Typography>
                
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          {/* Close and Action Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {(employeeData?.approvalStatus?.approver?.id == locatdatas?.id ||
              display) && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="gradient"
                    color="error"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="gradient"
                    color="success"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
              </>
            )}
            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default LeaveApproval;
